import React from 'react';
import styled from '@cthings.co/styled-components';
import { Text } from '@bit/first-scope.text';
import { ReactComponent as TypeIcon } from './assets/DeviceTypeIcon.svg';

import { colorFetchFDS as colorFetch } from '@cthings.co/styles-utils';

type WrapperProps = {
  margin?: string;
};

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  margin: ${({ margin }) => margin};
`;

type TypeNameProps = {
  borderBottom?: string;
};

const TypeName = styled(Text)<TypeNameProps>`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${colorFetch('gray1_5')};
  margin-left: 6px !important;
  border-bottom: ${({ borderBottom }) => borderBottom};
  line-height: 18px;
` as any; // @TODO

export interface DeviceTypeProps {
  type: string;
  margin?: string;
  borderBottom?: string;
}

export const DeviceType: React.FC<DeviceTypeProps> = ({ type, margin, borderBottom }) => {
  return (
    <Wrapper margin={margin}>
      <TypeIcon />
      <TypeName borderBottom={borderBottom}>{type}</TypeName>
    </Wrapper>
  );
};
